import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type SendTravelAlertOtpMutationVariables = Types.Exact<{
  input: Types.SendTravelAlertOtpInput;
}>;

export type SendTravelAlertOtpMutation = {
  __typename?: 'Mutation';
  sendTravelAlertOtp: { __typename?: 'TravelAlertSendOtpResult'; verified: boolean; channel: Types.TravelAlertChannel; phoneNumber?: string | null; email?: string | null };
};

export type VerifyTravelAlertOtpMutationVariables = Types.Exact<{
  input: Types.VerifyTravelAlertOtpInput;
}>;

export type VerifyTravelAlertOtpMutation = {
  __typename?: 'Mutation';
  verifyTravelAlertOtp: {
    __typename?: 'TravelAlertVerifyOtpResult';
    verified: boolean;
    channel: Types.TravelAlertChannel;
    phoneNumber?: string | null;
    email?: string | null;
    otpVerifyAttemptsUsed: number;
    otpVerifyMaxAttempts: number;
  };
};

export type CreateTravelAlertSubscriptionMutationVariables = Types.Exact<{
  input: Types.CreateTravelAlertSubscriptionInput;
}>;

export type CreateTravelAlertSubscriptionMutation = {
  __typename?: 'Mutation';
  createTravelAlertSubscription: {
    __typename?: 'TravelAlertSubscriptionDto';
    id: string;
    eventId: string;
    phoneNumber: string;
    email?: string | null;
    anonymousId?: string | null;
    source: Types.TravelAlertSubscriptionSource;
    status: Types.TravelAlertSubscriptionStatus;
    subscribedAlertTypes: Array<Types.TravelAlertTriggerType>;
    isVerifiedSubscription: boolean;
    consentAt: any;
    optedOutAt?: any | null;
    reEngagedAt?: any | null;
  };
};

export type UpdateTravelAlertSubscriptionMutationVariables = Types.Exact<{
  input: Types.UpdateTravelAlertSubscriptionInput;
}>;

export type UpdateTravelAlertSubscriptionMutation = {
  __typename?: 'Mutation';
  updateTravelAlertSubscription: {
    __typename?: 'TravelAlertSubscriptionDto';
    id: string;
    eventId: string;
    phoneNumber: string;
    email?: string | null;
    anonymousId?: string | null;
    source: Types.TravelAlertSubscriptionSource;
    status: Types.TravelAlertSubscriptionStatus;
    subscribedAlertTypes: Array<Types.TravelAlertTriggerType>;
    isVerifiedSubscription: boolean;
    consentAt: any;
    optedOutAt?: any | null;
    reEngagedAt?: any | null;
  };
};

export type TravelAlertSubscriptionQueryVariables = Types.Exact<{
  input: Types.TravelAlertSubscriptionQueryInput;
}>;

export type TravelAlertSubscriptionQuery = {
  __typename?: 'Query';
  travelAlertSubscription?: {
    __typename?: 'TravelAlertSubscriptionDto';
    id: string;
    eventId: string;
    phoneNumber: string;
    email?: string | null;
    anonymousId?: string | null;
    source: Types.TravelAlertSubscriptionSource;
    status: Types.TravelAlertSubscriptionStatus;
    subscribedAlertTypes: Array<Types.TravelAlertTriggerType>;
    isVerifiedSubscription: boolean;
    consentAt: any;
    optedOutAt?: any | null;
    reEngagedAt?: any | null;
  } | null;
};

export const SendTravelAlertOtpDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendTravelAlertOtp' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendTravelAlertOtpInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendTravelAlertOtp' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'verified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SendTravelAlertOtpMutationFn = Apollo.MutationFunction<SendTravelAlertOtpMutation, SendTravelAlertOtpMutationVariables>;

/**
 * __useSendTravelAlertOtpMutation__
 *
 * To run a mutation, you first call `useSendTravelAlertOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTravelAlertOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTravelAlertOtpMutation, { data, loading, error }] = useSendTravelAlertOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendTravelAlertOtpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendTravelAlertOtpMutation, SendTravelAlertOtpMutationVariables>) {
  return ApolloReactHooks.useMutation<SendTravelAlertOtpMutation, SendTravelAlertOtpMutationVariables>(SendTravelAlertOtpDocument, baseOptions);
}
export type SendTravelAlertOtpMutationHookResult = ReturnType<typeof useSendTravelAlertOtpMutation>;
export type SendTravelAlertOtpMutationResult = Apollo.MutationResult<SendTravelAlertOtpMutation>;
export type SendTravelAlertOtpMutationOptions = Apollo.BaseMutationOptions<SendTravelAlertOtpMutation, SendTravelAlertOtpMutationVariables>;
export const VerifyTravelAlertOtpDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'VerifyTravelAlertOtp' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'VerifyTravelAlertOtpInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verifyTravelAlertOtp' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'verified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'otpVerifyAttemptsUsed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'otpVerifyMaxAttempts' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type VerifyTravelAlertOtpMutationFn = Apollo.MutationFunction<VerifyTravelAlertOtpMutation, VerifyTravelAlertOtpMutationVariables>;

/**
 * __useVerifyTravelAlertOtpMutation__
 *
 * To run a mutation, you first call `useVerifyTravelAlertOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyTravelAlertOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyTravelAlertOtpMutation, { data, loading, error }] = useVerifyTravelAlertOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyTravelAlertOtpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyTravelAlertOtpMutation, VerifyTravelAlertOtpMutationVariables>) {
  return ApolloReactHooks.useMutation<VerifyTravelAlertOtpMutation, VerifyTravelAlertOtpMutationVariables>(VerifyTravelAlertOtpDocument, baseOptions);
}
export type VerifyTravelAlertOtpMutationHookResult = ReturnType<typeof useVerifyTravelAlertOtpMutation>;
export type VerifyTravelAlertOtpMutationResult = Apollo.MutationResult<VerifyTravelAlertOtpMutation>;
export type VerifyTravelAlertOtpMutationOptions = Apollo.BaseMutationOptions<VerifyTravelAlertOtpMutation, VerifyTravelAlertOtpMutationVariables>;
export const CreateTravelAlertSubscriptionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateTravelAlertSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateTravelAlertSubscriptionInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTravelAlertSubscription' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'anonymousId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subscribedAlertTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedSubscription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consentAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optedOutAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reEngagedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateTravelAlertSubscriptionMutationFn = Apollo.MutationFunction<CreateTravelAlertSubscriptionMutation, CreateTravelAlertSubscriptionMutationVariables>;

/**
 * __useCreateTravelAlertSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateTravelAlertSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTravelAlertSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTravelAlertSubscriptionMutation, { data, loading, error }] = useCreateTravelAlertSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTravelAlertSubscriptionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTravelAlertSubscriptionMutation, CreateTravelAlertSubscriptionMutationVariables>,
) {
  return ApolloReactHooks.useMutation<CreateTravelAlertSubscriptionMutation, CreateTravelAlertSubscriptionMutationVariables>(CreateTravelAlertSubscriptionDocument, baseOptions);
}
export type CreateTravelAlertSubscriptionMutationHookResult = ReturnType<typeof useCreateTravelAlertSubscriptionMutation>;
export type CreateTravelAlertSubscriptionMutationResult = Apollo.MutationResult<CreateTravelAlertSubscriptionMutation>;
export type CreateTravelAlertSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateTravelAlertSubscriptionMutation, CreateTravelAlertSubscriptionMutationVariables>;
export const UpdateTravelAlertSubscriptionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTravelAlertSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateTravelAlertSubscriptionInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTravelAlertSubscription' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'anonymousId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subscribedAlertTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedSubscription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consentAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optedOutAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reEngagedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateTravelAlertSubscriptionMutationFn = Apollo.MutationFunction<UpdateTravelAlertSubscriptionMutation, UpdateTravelAlertSubscriptionMutationVariables>;

/**
 * __useUpdateTravelAlertSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateTravelAlertSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTravelAlertSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTravelAlertSubscriptionMutation, { data, loading, error }] = useUpdateTravelAlertSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTravelAlertSubscriptionMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTravelAlertSubscriptionMutation, UpdateTravelAlertSubscriptionMutationVariables>,
) {
  return ApolloReactHooks.useMutation<UpdateTravelAlertSubscriptionMutation, UpdateTravelAlertSubscriptionMutationVariables>(UpdateTravelAlertSubscriptionDocument, baseOptions);
}
export type UpdateTravelAlertSubscriptionMutationHookResult = ReturnType<typeof useUpdateTravelAlertSubscriptionMutation>;
export type UpdateTravelAlertSubscriptionMutationResult = Apollo.MutationResult<UpdateTravelAlertSubscriptionMutation>;
export type UpdateTravelAlertSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateTravelAlertSubscriptionMutation, UpdateTravelAlertSubscriptionMutationVariables>;
export const TravelAlertSubscriptionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TravelAlertSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelAlertSubscriptionQueryInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelAlertSubscription' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'anonymousId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subscribedAlertTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedSubscription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consentAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optedOutAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reEngagedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTravelAlertSubscriptionQuery__
 *
 * To run a query within a React component, call `useTravelAlertSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTravelAlertSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelAlertSubscriptionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTravelAlertSubscriptionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TravelAlertSubscriptionQuery, TravelAlertSubscriptionQueryVariables>) {
  return ApolloReactHooks.useQuery<TravelAlertSubscriptionQuery, TravelAlertSubscriptionQueryVariables>(TravelAlertSubscriptionDocument, baseOptions);
}
export function useTravelAlertSubscriptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TravelAlertSubscriptionQuery, TravelAlertSubscriptionQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<TravelAlertSubscriptionQuery, TravelAlertSubscriptionQueryVariables>(TravelAlertSubscriptionDocument, baseOptions);
}
export type TravelAlertSubscriptionQueryHookResult = ReturnType<typeof useTravelAlertSubscriptionQuery>;
export type TravelAlertSubscriptionLazyQueryHookResult = ReturnType<typeof useTravelAlertSubscriptionLazyQuery>;
export type TravelAlertSubscriptionQueryResult = Apollo.QueryResult<TravelAlertSubscriptionQuery, TravelAlertSubscriptionQueryVariables>;
